import { views } from '../../constants/event';

const executeInitialState = {
  conversionInterval: 'NONE',
  result: null,
  executeTime: 0,
  view: views.CHART,
  executing: false,
  executeId: '',
};

const execute = (state = executeInitialState, action) => {
  switch (action.type) {
    case 'EXECUTE_FUNNEL_SUCCESS':
      return {
        ...state,
        result: action.result,
        executeTime: new Date().valueOf(),
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_FUNNEL_FAILURE':
      return {
        ...state,
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_FUNNEL':
      return {
        ...state,
        result: action.result,
        executeTime: new Date().valueOf(),
        executing: true,
      };

    case 'SET_FUNNEL_EXECUTE_ID':
      return {
        ...state,
        executeId: action.executeId,
      };

    case 'SET_CONVERSION_INTERVAL':
      return {
        ...state,
        conversionInterval: action.conversionInterval,
      };

    case 'SELECT_FUNNEL':
    case 'UPDATE_FUNNEL_SUCCESS':
    case 'DELETE_FUNNEL_SUCCESS':
      return {
        ...executeInitialState,
        conversionInterval: state.conversionInterval,
      };

    case 'CHANGE_FUNNEL_VIEW':
      return {
        ...state,
        view: action.view,
      };
    default:
      return state;
  }
};

export default execute;

export const getExecutionTime = (state) => state.executeTime;

export const getExecutionResult = (state) => state.result;

export const getConversionInterval = (state) => state.conversionInterval;

export const getSentQuery = (state) => state.sentQuery;

export const getView = (state) => state.view;

export const isExecuting = (state) => state.executing;

export const getExecuteId = (state) => state.executeId;
